/* 布局 */
//前台
import Layout from "@views/layout";

const activityqueansRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "activityqueans",
            name: "ACTIVITYQUEANS",
            meta: {
                title: "活动问题回答管理",
                sort: 1,
            },
            component: () => import("@views/business/activityqueans/index.vue"),
            redirect: {
                name: "ACTIVITYQUEANS_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "ACTIVITYQUEANS_LIST",
                    meta: {
                        title: "活动问题回答管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/activityqueans/list.vue"),
                },
                                                        ],
    },


        ],
};

export default activityqueansRouter;
